// extracted by mini-css-extract-plugin
export var inputFiles = "DialogApplicationForm-module--inputFiles--0be12";